module.exports = ["+86"]


//////////////////
// WEBPACK FOOTER
// ./src/config/area.json
// module id = byk8
// module chunks = 1